import * as definitions from '@database/common-schema/definitions';
import { mergeSchemas, schemaWithoutProps } from '@database/common-schema';
export const CaCategorySchema = {
    title: 'ICaCategory',
    type: 'object',
    schemaType: 'block',
    additionalProperties: false,
    properties: {
        _id: definitions.uuid,
        categoryName: { type: 'string', description: 'Category Name' },
        feedUuids: {
            type: 'array',
            items: definitions.uuid,
        },
    },
    required: ['_id', 'categoryName'],
};
export const AssemblerCategorySchema = mergeSchemas([
    CaCategorySchema,
    {
        type: 'object',
        title: 'IAssemblerCategory',
    },
]);
export const CaCategoryFeedlySchema = mergeSchemas([
    schemaWithoutProps(CaCategorySchema, ['feedUuids'], []),
    {
        type: 'object',
        title: 'ICaCategoryFeedly',
        properties: {
            feeds: {
                type: 'array',
                items: {
                    type: 'object',
                    additionalProperties: false,
                    properties: {
                        _id: definitions.uuid,
                        feedName: { type: 'string' },
                        partnerUuid: definitions.uuid,
                    },
                    required: ['_id', 'feedName', 'partnerUuid'],
                },
            },
        },
    },
]);
export const AssemblerCategoryFeedlySchema = mergeSchemas([
    schemaWithoutProps(AssemblerCategorySchema, ['feedUuids'], []),
    {
        type: 'object',
        title: 'IAssemblerCategoryFeedly',
        additionalProperties: false,
        properties: {
            feeds: {
                type: 'array',
                items: {
                    type: 'object',
                    additionalProperties: false,
                    properties: {
                        _id: definitions.uuid,
                        feedName: { type: 'string' },
                        partnerUuid: definitions.uuid,
                        partnerName: { type: 'string' },
                        logoUuid: { type: 'string' },
                    },
                    required: ['_id', 'feedName', 'partnerUuid'],
                },
            },
        },
    },
]);
//# sourceMappingURL=assembler.category.model.schema.js.map